import DownloadPdfComponent from "../../../DownloadPdfComponent/DownloadPdfComponent";
import "./BannerComponent.scss";
import imgVenetoMap from '../../../../assests/veneto-1.png';
import {useQuery} from "react-query";
import waferssServices from "../../../../hooks/waferssServices";
import globals from "../../../../config/appconfig";
import {AppContext} from "../../../../contexts/appContext";
import {useContext} from "react";

/**
 * @function BannerComponent BannerComponent
 * @returns {JSX.Element}
*/

const idValueRelazioneCompleta = "RelazioneCompletaPubblica";
const idValueRelazioneSintesi = "sintesi";

const BannerComponent = () => {
    const { getCheckPdf, getPdfCategory } = waferssServices();

    const { appYear } = useContext(AppContext);

    const { data: checkPdf } = useQuery(["checkPdf", idValueRelazioneCompleta], () => getCheckPdf(idValueRelazioneCompleta, { "pdfCompleto": true }), {
        enabled: !!(idValueRelazioneCompleta),
        refetchOnWindowFocus: false,
    });

    const { data: checkPdfSitensi } = useQuery(["checkPdf", idValueRelazioneSintesi], () => getCheckPdf(idValueRelazioneSintesi, { "pdfCompleto": true }), {
        enabled: !!(idValueRelazioneSintesi),
        refetchOnWindowFocus: false,
    });

    const dowloadPdf = () => {
        window.open( `${ globals[ "app-url-bucket" ] }/damrss/assets/allegati/RelazioneCompletaPubblica.pdf` );
    }
    

    const dowloadPdfSintensi = () => {
        window.open(`${globals["app-url-bucket"]}/damrss/assets/allegati/sintesi.pdf`);
    }

    return (
        <div className="Banner">
            <div className="p-relative BannerComponent d-flex justify-content-between">
                <div className="align-self-center BannerComponent__background">
                    <div className="BannerComponent__title fw-600 mb-1" tabIndex="0" role="contentinfo" aria-label={`Scarica il pdf della Relazione ${ appYear }`}>Scarica il pdf della Relazione {appYear}</div>
                    <div className="BannerComponent__subtitle" tabIndex="0" role="contentinfo" aria-label={`Scarica il pdf della Relazione ${ Number(appYear) - 1 }`}>(Base dati {Number(appYear) - 1})</div>
                    <div className="d-sm-flex ">
                        <div> <DownloadPdfComponent actionBtn={() => dowloadPdf()} classBtn={`${!(checkPdf?.data) ? "secondary disabled" : "secondary"}`}></DownloadPdfComponent></div>    
                        <div className="mt-1 mx-sm-3 mt-sm-0"><DownloadPdfComponent pdf={"false"} CategoryName={" Sintesi PDF"} actionBtn={() => dowloadPdfSintensi()} classBtn={`${!(checkPdfSitensi?.data) ? "secondary disabled" : "secondary"}`}></DownloadPdfComponent></div> 
                    </div>
                </div>
                <div className="align-self-center mt-4 d-none d-lg-block">
                    <img
                        src={ imgVenetoMap }
                        title={ "imgVenetoMap" }
                        alt={ "Veneto" }
                    />
                </div>
                {/* <div className="BannerComponent__ArtBoard d-flex "></div> */ }
            </div>
        </div>
    );
};


export default BannerComponent;